import axios from 'axios'

export default class CrystallizeService {
  static async updateProduct(productInfo) {
    return axios.put(`${process.env.VUE_APP_COMMERCE_API_BASEURL}/products`, productInfo)
  }
}
